import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SharedFilterState {
  values: { [group: string]: { [fieldName: string]: any } };
  urlKeys: { [group: string]: string };
}

const initialState: SharedFilterState = { values: {}, urlKeys: {} };

const sharedFiltersSlice = createSlice({
  name: 'sharedFilters',
  initialState,
  reducers: {
    setSharedFilter: (
      state,
      action: PayloadAction<{ group: string; fieldName: string; value: any }>,
    ) => {
      const { group, fieldName, value } = action.payload;
      if (!state.values[group]) state.values[group] = {};
      state.values[group][fieldName] = value;
    },
    initializeUrlFilters: (
      state,
      action: PayloadAction<{ group: string; urlKey: string; values: Record<string, unknown> }>,
    ) => {
      const { group, urlKey, values } = action.payload;
      if (state.urlKeys[group] === urlKey) return;
      state.values[group] = { ...state.values[group], ...values };
      state.urlKeys[group] = urlKey;
    },
  },
});

export const { setSharedFilter, initializeUrlFilters } = sharedFiltersSlice.actions;
export default sharedFiltersSlice.reducer;
